<div
  [class]="'pt-article-card pt-article-card_' + item().articleType"
  [ngClass]="{
    'pt-article-card_widget': widget(),
    'pt-article-card_read': item()?.read,
  }"
>
  <div class="pt-article-card__image-container">
    <img
      ptImageLoader
      class="pt-article-card__img"
      [src]="item().previewImage?.url || item().image.url"
    />

    @if (item().articleType !== 'faq' && item().read === false) {
      <div class="pt-article-card__new">
        {{ 'news.status.new' | translate }}
      </div>
    }

    <button
      class="pt-article-card__btn-toggle-saved"
      type="button"
      (click)="$event.stopPropagation(); toggleSaved.emit()"
    >
      @if (item().saved) {
        <pu-icon
          iconName="pinned"
          size="16"
        />
      } @else {
        <pu-icon
          iconName="pin"
          size="16"
        />
      }
    </button>
  </div>

  <div class="pt-article-card__panel">
    <div>
      <span class="pt-article-card__published"> {{ item().publishedAt | date:'dd MMM yy' }}</span>
      @if (!!item().minutesToRead) {
        <span class="pt-article-card__minutes-to-read"> | {{ item().minutesToRead }} {{
            'article.minutesToRead' | translate }}</span>
      }

    </div>

    <div class="pt-article-card__badges">
      @if (item().commentsCount) {
        <div class="pt-article-card__comments">
          <pu-icon
            iconName="comment"
            size="16"
          />
          {{ item().commentsCount }}
        </div>
      }
    </div>
  </div>

  <div class="pt-article-card__category__container">
    @if (item().category) {
      <div class="pt-article-card__category">
        {{ item().category.name }}
      </div>
    }

    @if (item().subcategory) {
      <div class="pt-article-card__category">
        {{ item().subcategory.name }}
      </div>
    }
  </div>

  <h3 class="pt-article-card__title">
    {{ item().title }}
  </h3>

  <a
    class="pt-article-card__link"
    [routerLink]="routerLink"
    (click)="onArticleClick()"
  >
  </a>
</div>
